var Shopify = Shopify || {};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number === null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ---------------------------------------------------------------------------
// Preloader
// ---------------------------------------------------------------------------
if ($("#preloader").length > 0) {
  $(window).on("load", function () {
    $("#preloader")
      .delay(1000)
      .fadeOut(1000, function () {
        if ($(".preloader-overflow").length > 0) {
          $("body").removeClass("preloader-overflow");
        }
      });
  });
}

// ---------------------------------------------------------------------------
// Slick sliders (vertical & horizontal)
// ---------------------------------------------------------------------------
$(document).ready(function () {
  initSliders();
});
$(window).on("resize", function () {
  initSliders();
});
function initSliders() {
  var winWidth = $(window).width();
  if (winWidth >= 769) slickVertical();
  else slickHorizontal();
}
function slickVertical() {
  if ($(".media-slick-slider .thumbnail-list").length > 0) {
    $(".thumbnail-list")
      .not(".slick-initialized")
      .slick({ vertical: true, verticalSwiping: true, slidesToShow: 4, slidesToScroll: 1 });
  }
}
function slickHorizontal() {
  if ($(".media-slick-slider .thumbnail-list").length > 0) {
    $(".thumbnail-list").slick("unslick");
  }
}

// ---------------------------------------------------------------------------
// Sticky bar scroll
// ---------------------------------------------------------------------------
$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  var width = $(window).width();
  if (width > 1024 && scrollTop >= 500) $(".sticky-bar").addClass("active");
  else if (width > 1024) $(".sticky-bar").removeClass("active");

  if (width <= 1024 && scrollTop >= 900) $(".sticky-bar").addClass("active");
  else if (width <= 1024) $(".sticky-bar").removeClass("active");
});

// ---------------------------------------------------------------------------
// Recently viewed toggle
// ---------------------------------------------------------------------------
$(document).ready(function () {
  $("#recently").click(function () {
    $("#recently-viewed-products").slideToggle(500);
  });
});

// ---------------------------------------------------------------------------
// Infinite scroll
// ---------------------------------------------------------------------------
var afterInfiniteLoaded = function () {
  $(".loading-image").removeClass("loading-image").addClass("loaded-image");
};
var AjaxMethod = $(".pagination-method-loadmore_btn").length > 0 ? "click" : "scroll";
if ($(".collection #AjaxinatePagination").length > 0) {
  new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

// ---------------------------------------------------------------------------
// Custom functions
// ---------------------------------------------------------------------------
InitCustomFunctions();
function InitCustomFunctions() {
  // Checkbox active state
  $(".facet-checkbox input:checkbox").each(function () {
    if ($(this).is(":checked")) $(this).parent(".facet-checkbox").addClass("active");
  });

  // Filter toggle
  const filter = document.querySelector(".toggleFilter");
  const sidebar = document.querySelector(".facets-vertical");
  const closeDiv = document.querySelector(".close-sidebar");
  if (filter && sidebar && closeDiv) {
    filter.addEventListener("click", () => {
      filter.classList.toggle("active");
      sidebar.classList.toggle("open");
      $("body").addClass("overflow-hidden filter-clicked");
    });
    closeDiv.addEventListener("click", () => {
      filter.classList.remove("active");
      sidebar.classList.remove("open");
      $("body").removeClass("overflow-hidden filter-clicked");
    });
  }

  // Product color variants
  if ($(".show-grouped__variant").length > 0) {
    $('input:radio[name="Color"]').click(function () {
      const cvariant = $(this).val();
      $(this).closest("fieldset").find(".form__label span").text(cvariant);
      $('input:radio[name="Color"]').next(".swatch-element").removeClass("clicked");
      $(this).next(".swatch-element").addClass("clicked");
      $(".slick-list").addClass("height_fix");
      $(".thumbnail-list__item").each(function () {
        const variant_val = $(this).find("img").attr("alt");
        if (cvariant === variant_val) {
          $(this).addClass("show").removeClass("hidden");
        } else {
          $(this).addClass("hidden").removeClass("show");
        }
      });
    });
  }

  // Color and size swatch clicks
  $(document).on("click", ".color-values a", function () {
    $(this).closest(".variant-option-color").find(".color-values a").removeClass("active");
    $(this).addClass("active");
  });
  $(document).on("click", ".size-values a", function () {
    $(".size-values a").removeClass("active");
    $(this).addClass("active");
  });
  $("body").on("click", ".color-values-plus a", function (e) {
    $(this).parents(".variant-option-color").find(".show-on-click").css("display", "flex");
    $(this).parents(".color-values-plus").css("display", "none");
    e.preventDefault();
  });

  // Item swatch update images
  $("body").on("click", ".swatch span", function () {
    const $parent = $(this).parents(".card-wrapper");
    const src = $(this).data("image");
    $parent.find(".card__inner .motion-reduce").attr("srcset", src);

    if ($(this).parents(".swatch").hasClass("color")) {
      const variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);

      const swatch_item = $(this).data("variant-item");
      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .size-values")
        .removeClass("active");

      $(this)
        .parents(".product-grid")
        .find(".variant-option-size .swatch")
        .each(function () {
          let swatch_size_vars = $(this)
            .find("span")
            .data("variant-title")
            .split("/")
            .map((n) => n.trim().toLowerCase().replace(/ /g, "-"));
          if (swatch_size_vars.includes(swatch_item)) $(this).parent(".size-values").toggleClass("active");
        });
    }

    if ($(this).parents(".swatch").hasClass("size")) {
      const variant = $(this).data("id");
      $(this).parents(".product-grid").find(".variant-push").val(variant);
    }
  });

  // Custom product grid
  $(".custom-product-grid li").click(function () {
    const classNames =
      "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop align-1-column align-2-column align-3-column align-4-column align-5-column";
    const getCols = $(this).data("cols");
    const getVal = "align-" + $(this).data("val") + "-column";
    $(".custom-product-grid li").removeClass("active");
    $(this).addClass("active");
    $("ul#product-grid").removeClass(classNames).addClass(getCols + " " + getVal);
  });

  // Filter buttons view toggle
  const viewExists = document.querySelector(".grid-view-button");
  if (viewExists && viewExists.classList.contains("layout-mode")) {
    const listViewButton = document.querySelector(".list-view-button");
    const gridViewButton = document.querySelector(".grid-view-button");
    const list = document.querySelector("ul.view-mode");
    const gridviewlist = document.querySelector(".custom-product-grid");

    listViewButton.onclick = function () {
      listViewButton.classList.add("active");
      gridViewButton.classList.remove("active");
      list.classList.remove("grid-view-filter");
      list.classList.add("list-view-filter");
      gridviewlist.classList.add("hidden");
    };
    gridViewButton.onclick = function () {
      listViewButton.classList.remove("active");
      gridViewButton.classList.add("active");
      list.classList.remove("list-view-filter");
      list.classList.add("grid-view-filter");
      gridviewlist.classList.remove("hidden");
    };
  }

  // Sidebar swiper
  if ($("#swiper-sidebar-carousel").length > 0) {
    new Swiper("#swiper-sidebar-carousel", {
      navigation: { nextEl: "#swiper-sidebar-next", prevEl: "#swiper-sidebar-prev" },
    });
  }

  // Remove loading images after 2s
  setTimeout(() => $(".loading-image").removeClass("loading-image").addClass("loaded-image"), 2000);

  // Sort radio buttons
  const radioButtons = document.querySelectorAll('.dt-sort__container input[name="sort_by"]');
  const optionSummary = document.querySelector('.dt-sort__container .facets__summary-label');
  radioButtons.forEach((radioButton) => {
    if (radioButton.checked && optionSummary) {
      optionSummary.innerHTML = radioButton.getAttribute("data-value");
    }
  });

  // Sticky search modal
  const topBtn = $("#dT_TopStickySearchBtn");
  const closeBtn = $(".dT_TopStickySearchCloseBtn");
  if (topBtn.length && closeBtn.length) {
    topBtn.click((ev) => {
      ev.preventDefault();
      $("#dT_top-sticky").addClass("search-show");
      $("#dT_top-sticky .search-modal").css("opacity", "1");
      $("body").addClass("search-overlay-open");
    });
    closeBtn.click((ev) => {
      ev.preventDefault();
      $("#dT_top-sticky").removeClass("search-show");
      $("#dT_top-sticky .search-modal").css("opacity", "0");
      $("body").removeClass("search-overlay-open");
    });
  }
}

// ---------------------------------------------------------------------------
// Custom select
// ---------------------------------------------------------------------------
$("ul.custom-select").on("click", "li:not(.init)", function () {
  const selectedVal = $(this).data("option-value");
  $(this).parents(".fbt-product__meta").find(".selectVariant option").attr("selected", false);
  $(this).parents(".fbt-product__meta").find('.selectVariant option[value="' + selectedVal + '"]').attr("selected", "selected").trigger("change");
});
$("ul.custom-select").on("click", ".init", function () {
  $(this).closest("ul.custom-select").children("li:not(.init)").toggle();
});
$("ul.custom-select").on("click", "li:not(.init)", function () {
  $(this).parent().children("li:not(.init)").removeClass("selected");
  $(this).addClass("selected");
  $(this).parent().children(".init").html($(this).html()).removeClass("li-unselected");
  $(this).parent().children("li:not(.init)").toggle();
  if ($("ul.custom-select li.init").hasClass("li-unselected")) $("#add-frequently-bought").prop("disabled", true);
  else $("#add-frequently-bought").prop("disabled", false);
});

// ---------------------------------------------------------------------------
// Loaded background images
// ---------------------------------------------------------------------------
window.onload = function () {
  setTimeout(() => $(".loading-image").removeClass("loading-image").addClass("loaded-image"), 3000);
};

// ---------------------------------------------------------------------------
// Stop videos on click outside iframe
// ---------------------------------------------------------------------------
jQuery(function () {
  jQuery().on("click", function () {
    jQuery("iframe")
      .contents()
      .find("video")
      .each(function () {
        this.currentTime = 0;
        this.pause();
      });
  });
});

// ---------------------------------------------------------------------------
// Header drawer close
// ---------------------------------------------------------------------------
const headerClose = document.querySelector(".header-drawer__close");
if (headerClose) headerClose.addEventListener("click", () => document.body.classList.remove("overflow-hidden-tablet"));

// ---------------------------------------------------------------------------
// Accessible nav submenu
// ---------------------------------------------------------------------------
setTimeout(() => $("#AccessibleNav .sub-menu-block").show(), 1000);

// ---------------------------------------------------------------------------
// Main content placeholder remove
// ---------------------------------------------------------------------------
$(document).ready(function () {
  setTimeout(() => $("#MainContent").removeClass("placeholder-shadow-blocks"), 1500);
});

// ---------------------------------------------------------------------------
// Tabs
// ---------------------------------------------------------------------------
$(function () {
  $(".acc__title").click(function (j) {
    const dropDown = $(this).closest(".dt-sc-tabs-content");
    $(".dt-sc-tabs-content").not(dropDown).slideUp();
    $(".dt-sc-tabs-content.active").removeClass("active");
    $(this).toggleClass("active");
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });

  $(".tablinks").click(function () {
    $(".dt-sc-tabs-content").removeClass("tab-active-content");
    $(".dt-sc-tabs-content[data-id='" + $(this).attr("data-id") + "']").addClass("tab-active-content");
    $(".tablinks").removeClass("active-tab");
    $(this).addClass("active-tab");
  });
});

// ---------------------------------------------------------------------------
// Hotspot
// ---------------------------------------------------------------------------
$(document).ready(hotSpot);
$(window).on("resize", hotSpot);
function hotSpot() {
  if ($(window).width() > 767) {
    $(".dt-sc-hotspot-item").each(function () {
      const pop = $(this).find(".dt-sc-hotspot-popup");
      pop.click((e) => e.stopPropagation());

      $(this).find("a.dt-sc-hotspot-marker").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = $(this).parent().parent();
        parentItem.addClass("this-hotspot-in-active");

        if ($(this).hasClass("clicked")) {
          $(this).removeClass("clicked");
          $(".this-hotspot-in-active").find("a.dt-sc-hotspot-marker").css("opacity", "0");
          $(this).css("opacity", "1");
          $(".dt-sc-hotspot-item").removeClass("open");
          $("a.dt-sc-hotspot-marker").css("opacity", "1");
        } else {
          $(this).addClass("clicked");
          $(".this-hotspot-in-active").find("a.dt-sc-hotspot-marker").css("opacity", "0");
          $(this).css("opacity", "1");
          $(this).parent().addClass("open");
          $(this).next(".dt-sc-hotspot-popup").toggleClass("dt-sc-popup-open");
          $(this).parent().siblings().children(".dt-sc-hotspot-popup").removeClass("dt-sc-popup-open");
        }
      });

      $(document).click(() => {
        $(".dt-sc-hotspot-wrapper").removeClass("this-hotspot-in-active");
        pop.removeClass("dt-sc-popup-open");
        $(".dt-sc-hotspot-item").removeClass("open");
        $("a.dt-sc-hotspot-marker").removeClass("clicked").css("opacity", "1");
      });
    });
  } else {
    $(".dt-sc-hotspot-popup").addClass("mfp-hide");
    $(".dt-sc-hotspot-marker").each(function () {
      $(this).magnificPopup({ type: "inline", closeOnBgClick: true, closeBtnInside: false, showCloseBtn: true });
    });
  }
}

// ---------------------------------------------------------------------------
// Clear console and Splitting.js
// ---------------------------------------------------------------------------
console.clear();
var s = Splitting();
